import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=7bf3755a&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf3755a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf3755a')) {
      api.createRecord('7bf3755a', component.options)
    } else {
      api.reload('7bf3755a', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=7bf3755a&scoped=true", function () {
      api.rerender('7bf3755a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Register.vue"
export default component.exports